
emojiPicker2ModalController.$inject = ['$scope', '$uibModalInstance'];
export function emojiPicker2ModalController($scope, $uibModalInstance) {

  $scope.close = close;
  $scope.emojiSelected = emojiSelected;

  init();

  function close() {
    $uibModalInstance.dismiss('close');
  }

  function emojiSelected(emojiText) {
    $uibModalInstance.close({ emojiText });
  }

  function init() {
  }

}
